// Enum for the different walking stages of a trip
export const WalkingType = Object.freeze({
  ORIGIN_TO_PICKUP: 'originToPickup',
  DROPOFF_TO_DESTINATION: 'dropoffToDestination'
});
